// ТОО «Перспективные материалы и технологии» (Almus) сайт мәліметтері
// Бұл файл компоненттермен бірге i18n аудармаларымен пайдаланылады.

export const COMPANY = {
  address: 'Республика Казахстан, город Алматы, 050010, ул. Шевченко, 29, офис 133',
  phone: '+7 701 736 2728',
  whatsapp: '+7 705 333 34 18',
  email: 'jans2009@mail.ru',
  website: 'http://pmt-almus.kz',
}

// Әлеуметтік желілер (Almus бренді)
export const SOCIALS = [
  {
    id: 'instagram',
    href: 'https://www.instagram.com/almus_kz',
    label: 'Instagram',
  },
  {
    id: 'facebook',
    href: 'https://www.facebook.com/share/1C516TzPn1/',
    label: 'Facebook',
  },
  {
    id: 'tiktok',
    href: 'https://vm.tiktok.com/ZMSax6FUf/',
    label: 'TikTok',
  },
]

// Өндіріс видеолары (public/videos ішінде)
export const VIDEOS = [
  { id: 'field', src: '/videos/almus-web-1.mp4', poster: '/videos/poster-1.jpg', captionKey: 'videos.caption1' },
  { id: 'presentation', src: '/videos/almus-web-2.mp4', poster: '/videos/poster-2.jpg', captionKey: 'videos.caption2' },
]

export const PRODUCTS = [
  {
    id: 'krs',
    slug: 'krs',
    composition: [
      { key: 'protein', value: '18–20%' },
      { key: 'fiber', value: '8–12%' },
      { key: 'vitamins', value: 'A, D, E' },
      { key: 'minerals', value: 'Ca, P, Mg' },
    ],
    instructions: {
      titleKey: 'usage',
      items: [
        { audienceKey: 'krs.young', dose: '2–3 кг/сутки', noteKey: 'krs.youngNote' },
        { audienceKey: 'krs.dairy', dose: '3–5 кг/сутки', noteKey: 'krs.dairyNote' },
        { audienceKey: 'krs.bull', dose: '5–7 кг/сутки', noteKey: 'krs.bullNote' },
      ],
    },
  },
  {
    id: 'mrs',
    slug: 'mrs',
    composition: [
      { key: 'protein', value: '14–16%' },
      { key: 'fat', value: '4–6%' },
      { key: 'energy', value: '2,5–3 МДЖ/кг' },
      { key: 'extra', value: 'пробиотиктер' },
    ],
  },
  {
    id: 'birds',
    slug: 'ptitsa',
    composition: [
      { key: 'protein', value: '18–22%' },
      { key: 'amino', value: 'лизин, метионин' },
      { key: 'minerals', value: 'кальций, фосфор' },
    ],
  },
  {
    id: 'pigs',
    slug: 'svini',
    composition: [
      { key: 'protein', value: '16–18%' },
      { key: 'starch', value: '30–35%' },
      { key: 'omega', value: 'омега-3' },
    ],
  },
  {
    id: 'universal',
    slug: 'universal',
    composition: [
      { key: 'balance', value: 'витаминдер + минералдар' },
      { key: 'formula', value: 'әмбебап' },
      { key: 'shelf', value: 'ұзақ сақтау мерзімі' },
    ],
  },
]

export const REVIEWS = [
  {
    id: 1,
    nameKey: 'reviewer1.name',
    roleKey: 'reviewer1.role',
    textKey: 'reviewer1.text',
  },
  {
    id: 2,
    nameKey: 'reviewer2.name',
    roleKey: 'reviewer2.role',
    textKey: 'reviewer2.text',
  },
]

export const POSTS = [
  {
    id: 'kak-pravilno-kormit-krs',
    slug: 'kak-pravilno-kormit-krs',
  },
  {
    id: 'laboratornye-ispytaniya',
    slug: 'laboratornye-ispytaniya',
  },
]

export const NAV = [
  { labelKey: 'nav.home', path: '/' },
  { labelKey: 'nav.products', path: '/assortiment' },
  { labelKey: 'nav.pricing', path: '/pricing' },
  { labelKey: 'nav.blog', path: '/blog' },
  { labelKey: 'nav.about', path: '/about' },
  { labelKey: 'nav.contact', path: '/contact' },
]